// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d1Dd","content":"styles_content__2wLMf","row":"styles_row__1w3b3","footer":"styles_footer__1eqhP","phraseLength":"styles_phraseLength__2EYwI"};